import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.every.js";
import RequirementsPreview from "./RequirementsPreview";
import { compose, withPropsOnChange, withHandlers, withState, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { camelizeProperties } from '@applyboard/ui-utils';
import { applicationSidebarToggleExpandedAction, applicationSetPreviewRequirementIdAction } from "../../../../store/actions/application";
import { applicationSidebarExpandedSelector, selectedPreviewRequirementIdSelector } from "../../../../store/selectors/application";
import { createApplicationRequirementsSelector } from "../../../../store/selectors/requirements";
import { applicationIdSelector } from '@applyboard/ab-common';
import componentErrorBoundary from "../../../../components/enhancers/componentErrorBoundary";
import { buildQuestionsArray } from "../RequirementCard/RequirementCard";
var enhancer = compose(componentErrorBoundary, connect(createStructuredSelector({
  sidebarExpanded: applicationSidebarExpandedSelector,
  application_requirements: createApplicationRequirementsSelector(),
  selectedPreviewRequirementId: selectedPreviewRequirementIdSelector,
  applicationId: applicationIdSelector
}), function (dispatch) {
  return {
    sidebarToggleExpanded: function sidebarToggleExpanded() {
      return dispatch(applicationSidebarToggleExpandedAction());
    },
    set_preview_requirement_id: function set_preview_requirement_id(id, fileId) {
      return dispatch(applicationSetPreviewRequirementIdAction(id, fileId));
    }
  };
}), withState('clickedAttachmentIndex', 'setClickedAttachmentIndex', null), withHandlers({
  previewRequirement: function previewRequirement(_ref) {
    var set_preview_requirement_id = _ref.set_preview_requirement_id,
      sidebarExpanded = _ref.sidebarExpanded,
      sidebarToggleExpanded = _ref.sidebarToggleExpanded,
      setClickedAttachmentIndex = _ref.setClickedAttachmentIndex;
    return function (requirement) {
      var _requirement$attachme, _requirement$attachme2;
      var attachmentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var index = attachmentIndex;
      if (attachmentIndex === null || attachmentIndex >= requirement.attachments.length || attachmentIndex < 0) {
        index = 0;
      }
      set_preview_requirement_id(requirement.id, (_requirement$attachme = requirement.attachments) === null || _requirement$attachme === void 0 ? void 0 : (_requirement$attachme2 = _requirement$attachme[index]) === null || _requirement$attachme2 === void 0 ? void 0 : _requirement$attachme2.id);
      sidebarExpanded && sidebarToggleExpanded();
      setClickedAttachmentIndex(index);
    };
  }
}), withPropsOnChange(['selectedPreviewRequirementId', 'application_requirements'], function (_ref2) {
  var selectedPreviewRequirementId = _ref2.selectedPreviewRequirementId,
    application_requirements = _ref2.application_requirements;
  var selectedPreviewRequirement = application_requirements.find(function (requirement) {
    return requirement.id === selectedPreviewRequirementId;
  });
  if (selectedPreviewRequirement !== null && selectedPreviewRequirement !== void 0 && selectedPreviewRequirement.attachments) {
    selectedPreviewRequirement.attachments = selectedPreviewRequirement.attachments.map(function (attachment) {
      var camelizedAttachment = camelizeProperties(attachment);
      camelizedAttachment.automatedVerificationResults = camelizedAttachment.automatedVerificationResults.map(function (verificationResult) {
        var result = camelizeProperties(verificationResult);
        if (result.outcome) {
          result.outcome = result.outcome.map(function (outcome) {
            return camelizeProperties(outcome);
          });
        }
        return result;
      });
      camelizedAttachment.automatedExtractionResults = camelizedAttachment.automatedExtractionResults.map(function (extractionResult) {
        var result = camelizeProperties(extractionResult);
        if (result.content) {
          result.content = result.content.map(function (content) {
            return camelizeProperties(content);
          });
        }
        return result;
      });
      return camelizedAttachment;
    });
  }
  var returnObj = {
    selectedPreviewRequirement: selectedPreviewRequirement
  };
  if (selectedPreviewRequirement && selectedPreviewRequirement.requirement_template_type === 'questions') {
    var questions = buildQuestionsArray({
      requirement: selectedPreviewRequirement,
      previewing: true
    });
    returnObj.questions = questions;
    returnObj.allQuestionsAnswered = questions.every(function (q) {
      return q.answer && q.answer.answer;
    });
  }
  return returnObj;
}), setPropTypes({
  allQuestionsAnswered: PropTypes.bool,
  previewRequirement: PropTypes.func,
  selectedPreviewRequirement: PropTypes.object,
  selectedPreviewRequirementId: PropTypes.number,
  set_preview_requirement_id: PropTypes.func,
  application_requirements: PropTypes.array,
  applicationId: PropTypes.number,
  sidebarExpanded: PropTypes.bool,
  sidebarToggleExpanded: PropTypes.func,
  requirementsList: PropTypes.array
}));
export default enhancer(RequirementsPreview);